import React from 'react';
import { Row, Col } from 'antd';
import {
  FileTextOutlined,
  UnorderedListOutlined,
  DollarOutlined,
  WalletOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { StatCard } from '../../../Component/ui';
import type { StatCardTone } from '../../../Component/ui';

interface CustomerSummaryStatsProps {
  customer: any;
}

const CustomerSummaryStats: React.FC<CustomerSummaryStatsProps> = ({ customer }) => {
  const { t } = useTranslation();
  const currency = t('common.currency', 'SAR');

  const summaryStats: Array<{
    title: string;
    value: React.ReactNode;
    tone: StatCardTone;
    icon: React.ReactNode;
  }> = [
    {
      title: t('customers.summary.totalInvoices', 'Total Invoices'),
      value: `${customer.total_invoices_amount || 0} ${currency}`,
      tone: 'info',
      icon: <FileTextOutlined />,
    },
    {
      title: t('customers.summary.invoiceCount', 'Invoice Count'),
      value: customer.total_invoices_count || 0,
      tone: 'success',
      icon: <UnorderedListOutlined />,
    },
    {
      title: t('customers.summary.totalDue', 'Total Due'),
      value: `${customer.total_out_standing || 0} ${currency}`,
      tone: 'warning',
      icon: <DollarOutlined />,
    },
    {
      title: t('customers.summary.closingBalance', 'Closing Balance'),
      value: `${customer.closing_balance || 0} ${currency}`,
      tone: 'violet',
      icon: <WalletOutlined />,
    },
    {
      title: t('customers.summary.overdue', 'Overdue'),
      value: `${customer.overdue || 0} ${currency}`,
      tone: 'danger',
      icon: <WarningOutlined />,
    },
  ];

  return (
    <Row gutter={[16, 16]} className="customer-stats-grid ui-stagger-children">
      {summaryStats.map((stat, index) => (
        <Col xs={24} sm={12} md={8} lg={4} key={stat.title}>
          <StatCard
            variant="glass"
            tone={stat.tone}
            icon={stat.icon}
            title={stat.title}
            value={stat.value}
            delay={index * 0.06}
          />
        </Col>
      ))}
    </Row>
  );
};

export default CustomerSummaryStats;
